/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { noop } from '@slardar/sdk-template';
import { getDefaultBrowser } from '../utils';
export var getBeaconTransport = function () {
    var window = getDefaultBrowser();
    // eslint-disable-next-line compat/compat
    return window && window.navigator.sendBeacon
        ? {
            get: function () { },
            post: function (url, data) {
                // eslint-disable-next-line compat/compat
                window.navigator.sendBeacon(url, data);
            },
        }
        : {
            get: noop,
            post: noop,
        };
};
//# sourceMappingURL=beacon.js.map